import { Modal, Row, Col, Card, CarouselItem, Table } from 'react-bootstrap'
import React, { Component } from 'react'
import parse, { domToReact } from 'html-react-parser';
import './summary.scss';

class TotalStudentDataModal extends Component {

    render() {
        let stateData = this.props.data;
        let questionid = stateData.slno;
        let questionData = this.props.data.studentResults.filter((item) => item.slno == questionid);
        let correct = questionData[0]?.studentResults?.filter((item)=>item.isCorrect == '2')
        let wrong = questionData[0]?.studentResults?.filter((item)=>item.isCorrect == '1')
        let unanswered = questionData[0]?.studentResults?.filter((item)=>item.isCorrect == '0')

        return (

            <Modal {...this.props}
                size="lg" aria-labelledby="example-modal-sizes-title-lg" className="">
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-lg text-center">Student Results</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Card as={Card.Body} className="bg-light my-2 text-center">
                        <Row>
                            <Col xl={4} lg={4} md={4} sm={12}>
                                <h6>Correct</h6>
                                {
                                    correct?.map((item) => {
                                        return (
                                            <p>{item.name}</p>
                                        )
                                    })
                                }
                            </Col>
                            <Col xl={4} lg={4} md={4} sm={12}>
                                <h6>Wrong</h6>
                                {
                                    wrong?.map((item) => {
                                        return (
                                            <p>{item.name}</p>
                                        )
                                    })
                                }
                            </Col>
                            <Col xl={4} lg={4} md={4} sm={12}>
                                <h6>Unanswered</h6>
                                {
                                    unanswered?.map((item) => {
                                        return (
                                            <p>{item.name}</p>
                                        )
                                    })
                                }
                            </Col>
                        </Row>
                    </Card>

                </Modal.Body>
            </Modal>
        )
    }
}

export default TotalStudentDataModal;
